import TemplateLibraryContainer from './TemplateLibrary.container.js'
import TemplateLibraryView from './TemplateLibrary.view.vue'

export default TemplateLibraryContainer(TemplateLibraryView)
